import { BaseService } from './base-service'
import { Observable } from 'rxjs'
import { BlacklistAPIConstant } from '@/api/constant/blacklist'
import { BlacklistConfigUpdateRequest, BlacklistQueryResp } from '@/api/model/blacklist'

export class BlacklistService extends BaseService {
    protected blacklistConstant: BlacklistAPIConstant
    constructor() {
        super()
        this.blacklistConstant = new BlacklistAPIConstant()
    }

    query(): Observable<BlacklistQueryResp> {
        return this.request(this.blacklistConstant.query())
    }

    update(data: BlacklistConfigUpdateRequest): Observable<Boolean> {
        return this.request(this.blacklistConstant.update(data))
    }
}
